<!-- eslint-disable -->
<template>
  <CommonPages id="blogDetail" :class="['blog-detail']" :title="pageTitle"
    :metaDescription="pageDescription">
    <div class="blog-detail-container" :class="[deviceType]">
      <!-- 博客详情头部 -->
      <div class="blog-header">
        <div class="blog-title">{{ blogData.title }}</div>
        <div v-if="blogData.author" class="blog-author">
          <!-- <img class="author-avatar" :src="blogData.avatar || defaultAvatar" alt="author avatar" /> -->
          <div class="author-name">{{ blogData.author }}</div>
          <div v-if="blogData.publishDate" class="publish-date">Publish: {{ blogData.publishDate }}
          </div>
        </div>
      </div>

      <!-- 博客封面图 -->
      <!-- <div v-if="blogData.image" class="blog-cover">
        <img :src="blogData.image" :alt="blogData.title">
      </div> -->

      <!-- 博客内容 -->
      <div class="blog-content">
        <div class="content-text" v-html="blogData.content"></div>
      </div>

      <!-- 相关推荐部分 -->
      <div class="related-posts">
        <!-- 标题部分 -->
        <div class="related-header">
          <div class="related-title">Relevant Posts</div>
        </div>

        <!-- 博客卡片列表 -->
        <div class="related-cards">
          <div class="related-card-link" v-for="(card, index) in visiblePosts" :key="index"
            @click="navigateToBlog(card)">
            <div class="related-card">
              <img class="card-image" :src="card.image" alt="blog image" />
              <div class="card-info">
                <div class="card-title">{{ card.title }}</div>
                <div class="card-author">
                  <div class="author-name">{{ card.author }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 导航控制区域 -->
        <div class="related-navigation">
          <div class="navigation-buttons">
            <div class="nav-button prev" @click="prevSlide"
              :class="{ 'disabled': currentSlide === 0 }">
              <img src="@/assets/default/arrow-right-small_w.svg" alt="previous"
                class="prev-icon" />
            </div>
            <div class="nav-button next" @click="nextSlide"
              :class="{ 'disabled': currentSlide >= Math.ceil(relatedPosts.length / itemsPerSlide) - 1 }">
              <img src="@/assets/default/arrow-right-small_w.svg" alt="next" class="next-icon" />
            </div>
          </div>

          <div class="view-more-button" @click="goToBlogList">
            <span>View More</span>
            <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow" class="arrow-icon" />
          </div>
        </div>
      </div>
    </div>
    <!-- 组合模块 -->
    <div class="combinations-section" :class="[deviceType]" v-if="combinations.length > 0">
      <div class="section-header">
        <div class="section-title">Combinations</div>
      </div>
      <div class="combinations-container">
        <div class="combination-row">
          <div class="combination-card-link" v-for="(combo, index) in combinations" :key="index"
            @click="navigateTo(combo.url)" @mouseenter="hoveredCombination = index"
            @mouseleave="hoveredCombination = null">
            <div class="combination-card" :class="{'hovered': hoveredCombination === index}">
              <div class="combination-text">
                {{ combo.title }}
              </div>
              <div class="see-more-button">
                <span>See More</span>
                <img src="@/assets/default/arrow-right-small_w.svg" alt="arrow"
                  class="arrow-icon" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 搜索过滤区域 -->
    <section class="search-sec-row" :class="[deviceType]">
      <div class="section-header" :class="[deviceType]">
        <div class="section-title">Search by Filter</div>
      </div>
      <div class="names-filter" :class="[deviceType]">
        <SearchFilter />
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import { mapGetters } from 'vuex';
import CommonPages from '@/pages/components/page_common.vue'
import allBlogs from '@/data/blogs.json'
import SearchFilter from '@/components/SearchFilter.vue';
import '@/css/blog_base.scss';

export default {
  name: 'BlogDetail',
  components: {
    CommonPages,
    SearchFilter
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      blogId: null,
      blogTitle: '',
      currentSlide: 0,
      itemsPerSlide: 4,
      blogData: {
        id: '',
        title: '',
        author: '',
        avatar: '',
        image: '',
        description: '',
        content: ''
      },
      relatedPosts: [],
      defaultAvatar: require('@/assets/placeholder.png'),
      combinations: [],
      hoveredCombination: null
    };
  },
  computed: {
    ...mapGetters([
      'deviceType',
      'domainConfig',
    ]),
    pageTitle () {
      return this.blogData?.title || '';
    },
    pageDescription () {
      const title = this.blogData?.title || '';
      return title ? `Dive into the story behind ${title}. Learn about naming culture, trends, and meanings.` : '';
    },
    visiblePosts () {
      const start = this.currentSlide * this.itemsPerSlide;
      const end = start + this.itemsPerSlide;
      return this.relatedPosts.slice(start, end);
    }
  },
  watch: {
    '$route.params.id': 'fetchBlogData'
  },
  mounted () {
    // 获取博客数据
    this.fetchBlogData();
    this.fetchCombinations();
  },
  methods: {
    async fetchCombinations () {
      const origin = this.domainConfig?.origin || '';
      try {
        const params = { origin };
        const response = await this.$global.server.postAPI({
          method: 'get',
          params,
          url: '/name/combinations',
        });
        if (response.data && response.data.combinations) {
          this.combinations = response.data.combinations.slice(0, 4);
        }
      } catch (error) {
        console.error('Error fetching combinations:', error);
        this.combinations = [];
      }
    },
    navigateTo (url) {
      if (url) {
        this.$router.push(url);
      }
    },
    fetchBlogData () {
      this.blogId = this.$route.params.id;
      const blog = allBlogs.find(b => b.id === this.blogId || b.routename === this.blogId);

      if (blog) {
        this.blogData = blog;
        document.title = this.blogData.title; // 更新页面标题

        // 根据domainConfig.blog过滤相关文章，并排除当前文章
        if (this.domainConfig && this.domainConfig.blog && this.domainConfig.blog.length) {
          this.relatedPosts = this.domainConfig.blog
            .map(id => allBlogs.find(b => b.id === String(id)))
            .filter(post => post && post.id !== this.blogData.id);
        } else {
          // 如果domainConfig.blog不存在，则使用默认的相关文章（排除当前篇）
          this.relatedPosts = allBlogs.filter(post => post.id !== this.blogData.id);
        }
      } else {
        console.error(`Blog with ID '${this.blogId}' not found.`);
        // Optionally, redirect to a 404 page
        // this.$router.push('/404');
      }
    },
    prevSlide () {
      if (this.currentSlide > 0) {
        this.currentSlide--;
      }
    },
    nextSlide () {
      const maxSlide = Math.ceil(this.relatedPosts.length / this.itemsPerSlide) - 1;
      if (this.currentSlide < maxSlide) {
        this.currentSlide++;
      }
    },
    navigateToBlog (card) {
      if (card && card.id) {
        // 使用routename生成url slug
        this.$router.push(`/blog/${card.routename}/${card.id}`);
      }
    },
    goToBlogList () {
      this.$router.push('/blog');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.blog-detail {
	// 博客详情容器
	.blog-detail-container {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;

		// 博客头部
		.blog-header {
			padding: rem(52) rem(180);
			display: flex;
			flex-direction: column;
			gap: rem(24);
			align-items: flex-start;
			width: 100%;
			box-sizing: border-box;

			.blog-title {
				color: #fff;
				font-size: rem(42);
				line-height: rem(52);
				font-weight: 900;
			}

			.blog-author {
				display: flex;
				flex-direction: row;
				gap: rem(12);
				align-items: center;

				.author-avatar {
					border-radius: rem(100);
					width: rem(32);
					height: rem(32);
					object-fit: cover;
				}

				.author-name {
					color: #fff;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 400;
					font-style: italic;
				}

				.publish-date {
					color: #fff;
					font-size: rem(16);
					line-height: rem(16);
					font-weight: 400;
					margin-left: rem(20);
				}
			}
		}

		// 博客封面图
		.blog-cover {
			width: 100%;
			padding: 0 rem(180);
			height: rem(480);
			overflow: hidden;
			margin-bottom: rem(40);

			img {
				width: 100%;
				height: 100%;
				object-fit: cover;
			}
		}

		// 博客内容
		.blog-content {
			padding: 0 rem(180);
			width: 100%;
			box-sizing: border-box;
			margin-bottom: rem(60);

			.content-text {
				color: #fff;
				font-size: rem(18);
				line-height: rem(32);

				h2 {
					font-size: rem(28);
					line-height: rem(36);
					font-weight: 700;
					margin: rem(32) 0 rem(16);
				}

				h3 {
					font-size: rem(22);
					line-height: rem(28);
					font-weight: 700;
					margin: rem(24) 0 rem(12);
				}

				p {
					margin-bottom: rem(16);
				}
			}
		}

		// 相关推荐部分
		.related-posts {
			width: 100%;
			padding: 0 rem(180) rem(60);
			box-sizing: border-box;

			.related-header {
				margin-bottom: rem(32);

				.related-title {
					color: #fff;
					font-size: rem(28);
					line-height: rem(28);
					font-weight: 900;
				}
			}

			.related-cards {
				display: flex;
				flex-wrap: wrap;
				gap: rem(24);
				margin-bottom: rem(40);

				.related-card-link {
					width: calc(25% - rem(18)); // 每行4个卡片
					text-decoration: none;
					padding: rem(2);
					border-radius: rem(16);
					background: transparent;
					transition: all 0.3s ease;

					&:hover {
						background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
					}
				}

				.related-card {
					background: rgb(26 26 26);
					border-radius: rem(14);
					cursor: pointer;
					display: flex;
					flex-direction: column;

					.card-image {
						border-radius: 12px;
						height: rem(168);
						width: 100%;
						object-fit: cover;
						padding: rem(8);
						padding-bottom: 0;
						box-sizing: border-box;
					}

					.card-info {
						padding: rem(16);
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						height: rem(120);
						box-sizing: border-box;

						.card-title {
							color: #fff;
							font-size: rem(16);
							line-height: rem(20);
							font-weight: 700;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							overflow: hidden;
							text-overflow: ellipsis;
						}

						.card-author .author-name {
							color: #fff;
							font-size: rem(12);
							line-height: rem(12);
							font-weight: 400;
							font-style: italic;
						}
					}
				}
			}

			// 导航控制区域
			.related-navigation {
				display: flex;
				flex-direction: row;
				align-items: center;
				justify-content: space-between;

				.navigation-buttons {
					display: flex;
					gap: rem(16);

					.nav-button {
						width: rem(28);
						height: rem(28);
						border-radius: rem(20);
						background: var(--Linear, linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%));
						display: flex;
						align-items: center;
						justify-content: center;
						cursor: pointer;
						transition: all 0.3s ease;

						&:hover {
							opacity: 0.8;
						}

						&.disabled {
							opacity: 0.5;
							cursor: not-allowed;
						}

						.prev-icon {
							transform: rotate(180deg);
							width: rem(6);
							height: rem(12);
							filter: brightness(0) invert(1);
						}

						.next-icon {
							width: rem(6);
							height: rem(12);
							filter: brightness(0) invert(1);
						}
					}
				}

				.view-more-button {
					border-radius: rem(8);

					background: var(--Linear, linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%));
					padding: rem(8) rem(16);
					display: flex;
					gap: rem(8);
					align-items: center;
					cursor: pointer;
					transition: all 0.3s ease;

					span {
						color: #fff;
						font-size: rem(12);
						line-height: rem(12);
						font-weight: 700;
					}

					.arrow-icon {
						width: rem(6);
						height: rem(12);
					}
				}
			}
		}

		// 移动端样式
		&.mobile {
			.blog-header {
				padding: rem(32) rem(16);

				.blog-title {
					font-size: rem(28);
					line-height: rem(36);
				}
			}

			.blog-cover {
				height: rem(240);
				padding: 0 rem(16);
			}

			.blog-content {
				padding: 0 rem(16);

				.content-text {
					font-size: rem(16);
					line-height: rem(28);

					h2 {
						font-size: rem(24);
						line-height: rem(32);
					}

					h3 {
						font-size: rem(20);
						line-height: rem(24);
					}
				}
			}

			.related-posts {
				padding: 0 rem(16) rem(40);

				.related-header {
					margin-bottom: rem(24);

					.related-title {
						font-size: rem(24);
						line-height: rem(24);
					}
				}

				.related-cards {
					flex-direction: column;
					gap: rem(16);
					margin-bottom: 0;

					.related-card-link {
						width: 100%;
						margin-bottom: rem(16);
					}
				}

				.related-navigation {
					flex-direction: column;
					gap: rem(16);
					align-items: center;

					.navigation-buttons {
						margin-bottom: rem(16);
					}

					.view-more-button {
						width: 100%;
						justify-content: center;
					}
				}
			}
		}
	}
	.combinations-section {
		padding: rem(40) rem(180) rem(80) rem(180);
		display: flex;
		flex-direction: column;
		gap: rem(24);

		.section-header .section-title {
			color: #ffffff;
			font-size: rem(24);
			font-weight: 900;
		}

		.combinations-container {
			.combination-row {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				gap: rem(24);
			}

			.combination-card-link {
				text-decoration: none;
				padding: rem(2);
				border-radius: rem(16);
				background: transparent;
				transition: all 0.3s ease;
				&:hover {
					background: linear-gradient(93deg, #08f 0%, #e54cba 50%, #c8ad17 100%);
				}
			}

			.combination-card {
				background: rgb(26, 26, 26);
				border-radius: rem(14);
				padding: rem(24);
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				height: rem(172);
				box-sizing: border-box;
				cursor: pointer;

				.combination-text {
					color: #ffffff;
					font-size: rem(18);
					line-height: rem(24);
					font-weight: 700;
				}

				.see-more-button {
					background: linear-gradient(92.87deg, #0088ff 0%, #e54cba 50%, #c8ad17 100%);
					border-radius: rem(8);
					padding: rem(8) rem(16);
					display: flex;
					align-items: center;
					justify-content: center;
					gap: rem(8);
					width: rem(100);
					height: rem(28);
					box-sizing: border-box;

					span {
						color: #ffffff;
						font-size: rem(12);
						font-weight: 700;
					}

					img {
						width: rem(6);
						height: rem(10);
						filter: brightness(0) invert(1);
					}
				}
			}
		}

		&.mobile {
			padding: rem(40) rem(16);
			.combinations-container {
				.combination-row {
					display: flex;
					overflow-x: auto;
					gap: rem(16);
					padding: 0 rem(16);
					margin: 0 rem(-16);
					&::-webkit-scrollbar {
						display: none;
					}
					-ms-overflow-style: none;
					scrollbar-width: none;
				}
				.combination-card-link {
					flex-shrink: 0;
					width: rem(280);
				}
			}
		}
	}

	.search-sec-row {
		padding: 0 rem(180) rem(80);
		&.mobile {
			padding: 0 rem(16) rem(40);
		}

		.section-header {
			margin-bottom: rem(24);

			.section-title {
				color: #fff;
				font-size: rem(24);
				font-weight: 900;
			}
		}
	}
}
</style> 